import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var SwitchCamera = createReactComponent("SwitchCamera", ["svg", defaultAttributes, [["path", {
  d: "M11 19H4a2 2 0 01-2-2V7a2 2 0 012-2h5",
  key: "7pmll5"
}], ["path", {
  d: "M13 5h7a2 2 0 012 2v10a2 2 0 01-2 2h-5",
  key: "ire0dq"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "3",
  key: "n6u7h6"
}], ["path", {
  d: "M18 22l-3-3 3-3",
  key: "1gmfgo"
}], ["path", {
  d: "M6 2l3 3-3 3",
  key: "yyfpu1"
}]]]);
export default SwitchCamera;